import { divRotate } from '../../utility/helpers';

/**
 * This helper class rotates the image and all layers inside it when the viewport is rotated.
 * @param viewport
 * @constructor
 */
export function ViewportRotator (viewport) {
  const $viewportDiv = viewport.vpDivGet()[0];
  // Pre-allocate to reduce the effects of garbage collection.
  let vpDivDims;
  let vpW;
  let vpH;

  // Expose the rotate change event
  this.rotateChange = ({angleRad}) => {
    vpDivDims = viewport.vpDivDimsGet();
    vpW = vpDivDims.w;
    vpH = vpDivDims.h;
    divRotate($viewportDiv, 0, 0, vpW, vpH, angleRad);
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/rendering/ViewportRotator.js